// extracted by mini-css-extract-plugin
export var displayNone = "_r7-6";
export var imgContainer = "_r7-2";
export var overflowHidden = "_r7-3";
export var productInfoCardButtonContainer = "_r7-5";
export var productTitleText = "_r7-4";
export var rightArrow = "_r7-1";
export var rightArrowContainer = "_r7-0";